import { render } from "./ViewDataPSBditerima.vue?vue&type=template&id=65ebcf43"
import script from "./ViewDataPSBditerima.vue?vue&type=script&lang=js"
export * from "./ViewDataPSBditerima.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__